export enum ConfigType {
	Basic,
	ReturnToScrollPosition,
}
